/** Corresponds to LoginController.LoginErrorType */
export const LOGIN_ERROR_TYPE = {
    None: 0,
    Unconfirmed: 1,
    LockedOut: 2,
    IncorrectCredentials: 3,
    NoMappedPrograms: 4,
    OtherError: 5,
    MfaRequired: 6,
    MfaCodeInvalid: 7,
    MfaSecretLocked: 8,
    SsoRequiredForUserInProgram: 9,
    DifferentProgramFound: 10,
    SelfRegistrationRequired: 11
};

/** Corresponds to UserLogin.ValidationStatus */
export const LOGIN_VALIDATION_STATUS = {
    Success: 0,
    EmailAddressNotFound: 1,
    LockedOut: 2,
    Unapproved: 3,
    AspUsernameNotRecognized: 4,
    IncorrectPassword: 5,
    OtherError: 6,
    MfaRequired: 7,
    MfaCodeInvalid: 8,
    MfaSecretLocked: 9,
    SsoRequiredForUserInProgram: 10,
    MfaSessionTokenMissing: 11,
    MfaSessionTokenExpired: 12,
    MfaSessionTokenMismatch: 13
};
